import styled, { css } from 'vue-styled-components';
import { FONTS } from '../../../../constants';
import { COLORS } from '../../../../colors';

export const Container = styled.div``;

const tooltipStyle = css`
  font-size: 20px;
  font-family: ${FONTS.ARIAL};
`;

export const TooltipTitle = styled.h1`
  ${tooltipStyle};
  font-weight: 600;
  margin: 0;
  color: ${COLORS.DARK_GRAY};
  padding: 0.5em 0.5em;
  text-align: left;
`;

export const TooltipValue = styled.div`
  ${tooltipStyle};
  color: ${COLORS.SHARK};
  font-weight: 400;
  padding: 0 0.5em 0.5em;
  line-height: 1.125;
`;
